
import React from "react";
import MapPreview from "./MapPreview";
import { MapErrorBoundary } from "./MapErrorBoundary";
import { DiagnosticUtils } from "../../utils/diagnosticUtils";

interface MapRendererProps {
  mapUrls: string[];
  onViewChange?: (view: { lat: number; lng: number; heading: number; pitch: number }) => void;
}

const MapRenderer: React.FC<MapRendererProps> = ({ mapUrls, onViewChange }) => {
  if (mapUrls.length === 0) return null;

  // Run diagnostics on map URLs
  React.useEffect(() => {
    if (mapUrls.length > 0) {
      console.log('🗺️ MapRenderer: Analyzing map URLs for diagnostics');
      mapUrls.forEach((url, index) => {
        console.log(`🗺️ MapRenderer: URL ${index + 1}:`);
        DiagnosticUtils.analyzeMapUrl(url);
      });
    }
  }, [mapUrls]);

  return (
    <div className="mt-3 space-y-2">
      {mapUrls.map((url, index) => {
        console.log(`🗺️ MapRenderer: Rendering MapPreview ${index + 1} for URL:`, url);
        return (
          <MapErrorBoundary 
            key={index}
            onError={(error, errorInfo) => {
              console.error(`🗺️ MapRenderer: Error in MapPreview ${index + 1}:`, error, errorInfo);
              DiagnosticUtils.analyzeMapUrl(url);
            }}
          >
            <MapPreview url={url} onViewChange={onViewChange} />
          </MapErrorBoundary>
        );
      })}
    </div>
  );
};

export default MapRenderer;
